export default "__VITE_ASSET__CaM3Me8a__"